import { LINKS } from '@fans-fund-me/shared-comm-react-cosmos/fans-fund-me/links';
import { Screen } from '@fans-fund-me/shared-comm-react-cosmos/fans-fund-me/register-account-type-screen';
import { useForm } from '@mantine/form';
import { useState } from 'react';
import { useNavigate } from 'react-router';

function RegisterAccountType() {
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const form = useForm({
    mode: 'uncontrolled',
    initialValues: {
      account_type: '',
    },
  });

  const handleSubmit = (values: typeof form.values) => {
    setIsLoading(true);
    localStorage.setItem('ffm_register_account_type', values.account_type);
    navigate(LINKS.REGISTER_COUNTRY);
  };

  return <Screen form={form} handleSubmit={handleSubmit} isLoading={isLoading} />;
}

export default RegisterAccountType;
